import { Image } from '@ckeditor/ckeditor5-image'
import { LinkImage as LinkImageBase, LinkEditing, LinkUI, AutoLink, LinkConfig } from '@ckeditor/ckeditor5-link'
import ImageUtils from '@ckeditor/ckeditor5-image/src/imageutils'
import { Plugin } from '@ckeditor/ckeditor5-core'

export class LinkImage extends LinkImageBase {
  static get requires() {
    // LinkImage needs Image loaded, but does not declare it.
    // Since we do custom build, we can declare it without issue.
    return [Image, ImageUtils, ...LinkImageBase.requires] as any
  }
}

export class Link extends Plugin {
  static get requires() {
    return [LinkEditing, LinkUI, AutoLink]
  }

  /**
   * @inheritDoc
   */
  static get pluginName() {
    return 'Link'
  }
}

declare module '@ckeditor/ckeditor5-core/src/editor/editorconfig' {
  interface EditorConfig {
    link?: LinkConfig
  }
}
